<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4 col-xlg-3 col-md-5">
        <div class="card">
          <div class="card-body text-center">
            <div class="profile-pic m-b-20 m-t-20">
              <img src="../../../assets/images/users/1.jpg" width="150" class="rounded-circle" alt="user">
              <h4 class="m-t-20 m-b-0">
                Daniel Kristeen
              </h4>
              <a href="mailto:danielkristeen@gmail.com">danielkristeen@gmail.com</a>
            </div>
          </div>
          <div class="p-25 border-top m-t-15">
            <div class="row text-center">
              <div class="col-6 border-right">
                <router-link :to="{ name: 'myprofile'}" class="link d-flex align-items-center justify-content-center font-medium">
                  <i class="mdi mdi-account font-20 m-r-5" />&nbsp;Edit Profile
                </router-link>
              </div>
              <div class="col-6">
                <router-link :to="{name: 'wallet'}" class="link d-flex align-items-center justify-content-center font-medium">
                  <i class="mdi mdi-bank font-20 m-r-5" />&nbsp;Banking
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Your Profile
            </h4>
            <h6 class="card-subtitle">
              Please keep your profile information always current in order to help you when you contact us.
            </h6>
          </div>
          <hr>
          <form class="form-horizontal">
            <div class="card-body">
              <h4 class="card-title">
                Personal Info
              </h4>
              <div class="form-group row">
                <label for="fname" class="col-sm-3 text-right control-label col-form-label">First Name</label>
                <div class="col-sm-9">
                  <input id="fname" type="text" class="form-control" placeholder="First Name Here">
                </div>
              </div>
              <div class="form-group row">
                <label for="lname" class="col-sm-3 text-right control-label col-form-label">Last Name</label>
                <div class="col-sm-9">
                  <input id="lname" type="text" class="form-control" placeholder="Last Name Here">
                </div>
              </div>
              <div class="form-group row">
                <label for="email1" class="col-sm-3 text-right control-label col-form-label">Email</label>
                <div class="col-sm-9">
                  <input id="email1" type="email" class="form-control" placeholder="Email Here">
                </div>
              </div>
              <div class="form-group row">
                <label for="cono1" class="col-sm-3 text-right control-label col-form-label">Contact No</label>
                <div class="col-sm-9">
                  <input id="cono1" type="text" class="form-control" placeholder="Contact No Here">
                </div>
              </div>
            </div>
            <hr>
            <div class="card-body">
              <h4 class="card-title">
                Requirements
              </h4>
              <div class="form-group row">
                <label for="com1" class="col-sm-3 text-right control-label col-form-label">Company</label>
                <div class="col-sm-9">
                  <input id="com1" type="text" class="form-control" placeholder="Company Name Here">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label">Interested In</label>
                <div class="col-sm-9">
                  <select class="form-control">
                    <option>Choose Your Option</option>
                    <option>Desiging</option>
                    <option>Development</option>
                    <option>Videography</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label">Budget</label>
                <div class="col-sm-9">
                  <select class="form-control">
                    <option>Choose Your Option</option>
                    <option>Less then $5000</option>
                    <option>$5000 - $10000</option>
                    <option>$10000 - $20000</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label">Select File</label>
                <div class="col-sm-9">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Upload</span>
                    </div>
                    <div class="custom-file">
                      <input id="inputGroupFile01" type="file" class="custom-file-input">
                      <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="abpro" class="col-sm-3 text-right control-label col-form-label">About Project</label>
                <div class="col-sm-9">
                  <input id="abpro" type="text" class="form-control" placeholder="About Project Here">
                </div>
              </div>
            </div>
            <hr>
            <div class="card-body">
              <div class="offset-sm-3 col-sm-9">
                <div class="button-group">
                  <button type="submit" class="btn btn-info waves-effect waves-light">
                    Save
                  </button>
                  <button type="reset" class="btn btn-secondary waves-effect waves-light">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyProfile'
}
</script>

<style scoped>
</style>
